module.exports = __webpack_public_path__ + "static/media/3dShooter.3b868257.webp";